/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import AppBar from '@mui/material/AppBar';
import StyledProps from '../../theme/AppThemeInterface';
import { breakpoints } from '../../../materialui_wrappers/utils/StyledComponentsBreakpoints';

const ViewHeaderWrapper = styled(AppBar)`
  box-shadow: none !important;
  transition: padding 100ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
  position: fixed;
  top: ${({ theme }: StyledProps) => theme.appHeaderHeightSmall};
  left: ${({ theme }: StyledProps) => theme.appHeaderHeightSmall};

  @media print {
    background-color: white;
    position: static;
  }

  // The MuiPaper element of the side nav has a z-index of 1200, so this places the view header below the side nav
  z-index: 1199;

  .viewheader {
    // Bottom border that does not increase the component size
    -webkit-box-shadow: inset 0 -1px 0 ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
    -moz-box-shadow: inset 0 -1px 0 ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
    box-shadow: inset 0 -1px 0 ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};

    min-height: ${({ theme }: StyledProps) => theme.viewHeaderHeightSmall};

    @media only screen and (min-width: ${breakpoints.sm}px) {
      min-height: ${({ theme }: StyledProps) => theme.viewHeaderHeightLarge};
    }

    @media print {
      box-shadow: none;
    }

    > h1 {
      font-family: ${({ theme }: StyledProps) => theme.viasatFontFamilyThin};

      font-size: 16px;
      margin-left: 16px;
      letter-spacing: 0.05rem;

      .viewheader__count {
        font-family: ${({ theme }: StyledProps) => theme.viasatFontFamilyThin};
        letter-spacing: 0.05rem;
      }

      @media print {
        margin-left: 0px;
      }
    }
  }

  .fleet__view__online__terminal__count {
    margin-left: 1rem;
  }
`;

export default ViewHeaderWrapper;
